if (!customElements.get('line-coupon')) {
  customElements.define('line-coupon', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const close = this.querySelector('.line-coupon__close');
      const key = 'fairway-lily-line-coupon-dismissed';
      let dismissed = false;
      try { dismissed = sessionStorage.getItem(key) === '1'; } catch (_) { /* Storage may be blocked. */ }
      const fv = this.hasAttribute('data-after-fv') ? document.querySelector('fv-slideshow') : null;
      const updateVisibility = () => {
        this.hidden = dismissed || Boolean(fv && fv.getBoundingClientRect().bottom > 0);
      };
      updateVisibility();
      if (fv) {
        this.fvObserver = new IntersectionObserver(updateVisibility);
        this.fvObserver.observe(fv);
      }
      close.addEventListener('click', () => {
        close.blur();
        dismissed = true;
        this.hidden = true;
        try { sessionStorage.setItem(key, '1'); } catch (_) { /* Closing still works without storage. */ }
      });
    }

    disconnectedCallback() {
      this.fvObserver?.disconnect();
    }
  });
}
